import React from "react";
import s from "./PageSummary.module.scss";
import { useLandingCurrencyContext } from "@iliotech/data-wire";
import { classNames } from "@progress/kendo-react-common";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";
import { useNavigate, useParams } from "react-router";
import { FadeLoading } from "@iliotech/component-library";
import { DropDownList } from "@progress/kendo-react-dropdowns";
interface IProps {
  data: {
    portfolios: number;
    totalMarketValue: number;
    workgroups: number;
    loading?: boolean;
  };
}

export const PageSummary = ({ data }: IProps) => {
  const positiveNav = data?.totalMarketValue > 0;
  const { workgroupName } = useParams();
  const navigate = useNavigate();
  const { currencies, currency, setCurrency } = useLandingCurrencyContext();
  const valueFormatter = (v: number) =>
    v?.toLocaleString(undefined, {
      maximumFractionDigits: 0,
    });

  const onCreatePortfolio = () => {
    if (workgroupName) {
      navigate("/create-portfolio/" + workgroupName);
    } else {
      navigate("/create-portfolio/select");
    }
  };
  return (
    <FadeLoading loading={data?.loading}>
      <div className={s.row}>
        <article>
          <div className={s.row}>
            <DropDownList
              popupSettings={{ popupClass: "illio-combo" }}
              className={classNames(s.dropdown, positiveNav && s.positive)}
              value={currency}
              onChange={(event) => {
                setCurrency(event?.target?.value as any);
              }}
              data={currencies as any}
            />

            <h2 className={classNames(s.nav, positiveNav && s.positive)}>
              {valueFormatter(data?.totalMarketValue) || 0}
            </h2>
            {positiveNav ? (
              <GoTriangleUp
                size={21}
                style={{ color: "var(--good)", minWidth: 8 }}
              />
            ) : (
              <GoTriangleDown
                size={21}
                style={{ color: "var(--bad)", minWidth: 8 }}
              />
            )}
          </div>
          <span className={classNames("detail", s.bottom)}>TOTAL NAV</span>
        </article>
        {!workgroupName && (
          <article>
            <h2>{data?.workgroups || 0}</h2>
            <span className={classNames("detail", s.bottom)}>WORKGROUPS</span>
          </article>
        )}
        <article>
          <h2>{data?.portfolios || 0}</h2>
          <span className={classNames("detail", s.bottom)}>PORTFOLIOS</span>
        </article>
        <article onClick={onCreatePortfolio} className={s.button}>
          <span>+ Add new portfolio</span>
        </article>
      </div>
    </FadeLoading>
  );
};
